import PestPillarLayout from "../PestPillarLayout";

const PROBLEMS = [
  {
    title: "Frelons asiatiques Aubusson",
    desc: "Aubusson et la vallée de la Creuse abritent une forte population de frelons asiatiques. Nids en hauteur dans les arbres, cheminées, toitures anciennes du centre historique.",
  },
  {
    title: "Rats dans le bâti ancien",
    desc: "Aubusson (patrimoine tapissier UNESCO) compte de nombreux bâtiments anciens propices aux rongeurs. Dératisation adaptée avec respect du patrimoine.",
  },
  {
    title: "Punaises de lit",
    desc: "Hôtels, chambres d'hôtes, Cité internationale de la tapisserie : traitement vapeur sèche 180 °C sans produit chimique, discret pour l'accueil touristique.",
  },
  {
    title: "Cafards et blattes",
    desc: "Restauration, boulangeries, cuisines anciennes du centre d'Aubusson. Traitement HACCP-conforme avec attestation.",
  },
  {
    title: "Chenilles processionnaires",
    desc: "Les alentours d'Aubusson (Felletin, La Nouaille) comptent nombreux pins hôtes de chenilles processionnaires. Éco-pièges et échenillage.",
  },
  {
    title: "Fouines dans les combles",
    desc: "Bâtis anciens d'Aubusson favorables aux fouines. Solution de neutralisation et colmatage des points d'entrée pour éviter la récidive.",
  },
];

const FAQ = [
  {
    q: "Quel délai pour intervenir à Aubusson ?",
    a: "Aubusson est à environ 1 h de notre siège. Nous intervenons sous 48-72 h pour les demandes standards, et dans la journée pour les urgences (nid de frelons actif en zone touristique, invasion massive). Devis à distance par photo pour gagner du temps.",
  },
  {
    q: "Traitez-vous les hôtels et chambres d'hôtes d'Aubusson ?",
    a: "Oui, notre spécialité inclut le tourisme : hébergeurs d'Aubusson, Felletin et alentours. Traitement vapeur sèche discret sans éviction, contrats de prévention annuels, intervention prioritaire en cas de suspicion punaise de lit. Confidentialité totale.",
  },
  {
    q: "Intervenez-vous dans les bâtiments patrimoniaux ?",
    a: "Oui, avec le plus grand respect. Nous adaptons nos méthodes aux contraintes du bâti ancien d'Aubusson (charpentes en bois, tapisseries, patrimoine classé). Vapeur sèche sur textiles fragiles, biocides ciblés à faible dosage sur charpentes, aucun produit dispersé.",
  },
  {
    q: "Combien coûte une intervention à Aubusson ?",
    a: "Tarifs identiques au reste de la Creuse (aucun surcoût de déplacement) : 90-180 € pour un nid de frelons, 150-450 € pour un traitement anti-punaises selon la surface, 100-200 € pour cafards en cuisine. Devis gratuit après visite ou photo.",
  },
];

export default function AntiNuisiblesAubusson() {
  return (
    <PestPillarLayout
      slug="anti-nuisibles-aubusson"
      seoTitle="Anti-nuisibles Aubusson (23) — Frelons, rats | K'REUSE"
      seoDescription="Anti-nuisibles à Aubusson (23) : frelons, dératisation, désinsectisation, punaises en gîtes. Intervention 48h, Certibiocide."
      breadcrumbLabel="Anti-nuisibles Aubusson"
      heroBadge="Aubusson · Creuse (23)"
      heroTitleHtml={`Anti-nuisibles à <span class="font-medium text-[#1B5E20]">Aubusson</span>`}
      heroSubtitle="Frelons, rats, punaises de lit dans les hôtels, cafards en restauration, chenilles processionnaires : nous intervenons à Aubusson, Felletin, La Nouaille et alentours avec le plus grand respect du patrimoine."
      hero_h2="Votre entreprise anti-nuisibles à Aubusson et Felletin"
      introParagraphs={[
        "Aubusson, capitale de la tapisserie (UNESCO), et Felletin, sa voisine, cumulent les défis anti-nuisibles particuliers : bâtis anciens propices aux rongeurs et aux fouines, patrimoine sensible aux produits chimiques, activité touristique exposée aux punaises de lit, et environnement forestier accueillant frelons asiatiques et chenilles processionnaires.",
        "K'REUSE EXTÉRIEUR intervient à Aubusson depuis notre siège de La Celle-Dunoise (environ 1 h) avec une expertise spécifique au patrimoine et au tourisme. Nous adaptons nos méthodes : vapeur sèche sur les textiles fragiles et matelas d'hôtels, biocides à faible dosage ciblé pour les charpentes de bâti classé, protocole discret pour l'accueil touristique.",
        "Certifié Certibiocide, nous travaillons régulièrement avec les hôteliers, chambres d'hôtes, restaurateurs et gestionnaires de patrimoine d'Aubusson et Felletin. Confidentialité contractuelle, attestation d'intervention systématique, contrats annuels de prévention disponibles pour les hébergeurs touristiques.",
      ]}
      problems={PROBLEMS}
      method={[
        { title: "Contact", desc: "Diagnostic à distance ou visite. Adaptation au calendrier touristique (interventions hors saison ou nuit possibles pour hôteliers)." },
        { title: "Devis clair", desc: "Devis détaillé incluant méthode, produits, temps d'éviction si applicable. Aucun surcoût de déplacement." },
        { title: "Intervention", desc: "Déplacement à Aubusson avec matériel adapté au patrimoine. Vapeur sèche privilégiée sur textiles/matelas. Biocides ciblés sur charpentes." },
        { title: "Attestation", desc: "Certificat d'intervention remis aux professionnels HACCP et hébergeurs touristiques. Contrôle post-traitement selon protocole." },
      ]}
      cities={["Felletin", "La Nouaille", "Saint-Amand", "Blessac", "Saint-Alpinien", "Saint-Marc-à-Loubaud", "Néoux"]}
      faq={FAQ}
      ctaTitle="Un problème de nuisibles à Aubusson ?"
      whatsappText="Bonjour, j'ai besoin d'une intervention anti-nuisibles à Aubusson."
    />
  );
}
